;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:localcoin":true});}catch(e){}}();export const parseJson = <T>(item: string | undefined | null): T | null => {
  if (!item) {
    return null;
  }

  try {
    const parsedJson = JSON.parse(item);

    return parsedJson;
  } catch {
    return null;
  }
};
